<template>
  <div class="service-wrap" v-if="course.service && course.service.length > 0">
    <span class="label">课程服务：</span>
    <div class="container clearfix">
      <div ref="services" class="services">
        <span
          class="service"
          v-for="s in course.service.map(s => s.name)"
          :key="s"
        >
          <i class="el-icon-circle-check"></i>
          <span>{{ s }}</span>
        </span>
      </div>
      <div class="more" v-if="hasServiceMore">···</div>
    </div>
    <div class="service-popper" v-if="hasServiceMore">
      <span
        class="service"
        v-for="s in course.service.map(s => s.name)"
        :key="s"
      >
        <i class="el-icon-circle-check"></i>
        <span>{{ s }}</span>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseShowService",
  props: {
    course: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      hasServiceMore: false,
    };
  },
  watch: {
    course: function () {
      this.$nextTick(() => {
        this.setServiceMore();
      });
    },
  },
  created() {
    this.$nextTick(() => {
      this.setServiceMore();
    });
  },
  methods: {
    setServiceMore() {
      if (!this.$refs.services) {
        return;
      }
      if (this.$refs.services.clientHeight > 20) {
        this.hasServiceMore = true;
      } else {
        this.hasServiceMore = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.service-wrap {
  font-size: 14px;
  display: flex;
  position: relative;

  &:hover {
    .service-popper {
      display: block;
    }
  }

  .label {
    color: #999;
    flex-shrink: 0;
    margin-right: 8px;
  }

  .container {
    flex-grow: 1;
    height: 20px;
    overflow: hidden;
    margin-bottom: 15px;
    position: relative;
  }

  .more {
    float: left;
    color: #999999;
  }

  .services {
    width: 540px;
    float: left;
  }

  .service {
    margin: 0 12px 0 0;
    display: inline-block;

    .el-icon-circle-check {
      margin-right: 5px;
      color: #ff2d28;
    }
  }

  .service-popper {
    position: absolute;
    left: 0;
    top: 26px;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    border-radius: 5px;
    padding: 15px 15px 0 15px;
    display: none;
    z-index: 99;

    &::before {
      content: "";
      position: absolute;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-bottom-color: white;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }

    .service {
      margin-bottom: 15px;
    }
  }
}
</style>
